export default __webpack_public_path__ + "static/3_36-0c979a1884c95d73b7862a1c15e640b1.png";